(() => {
  // Name -> hex map (your fixed palette)
  const COLOR_MAP = {
    "navy": "#1f2a44",
    "black": "#111111",
    "white": "#ffffff",
    "light blue": "#9fc5e8",
    "military green": "#556b4f",
    "charcoal": "#4a4a4a",
  };

  const normalize = (s) =>
    (s || "")
      .toString()
      .trim()
      .toLowerCase()
      .replace(/[_-]+/g, " ")
      .replace(/\s+/g, " ");

  const getSwatchLabelValue = (label) => {
    // Most Dawn swatch labels have title="ColorName"
    const t = label.getAttribute("title");
    if (t) return t;

    // Fallback: visually-hidden text inside label
    const vh = label.querySelector(".visually-hidden");
    if (vh && vh.textContent) return vh.textContent;

    return label.textContent || "";
  };

  const applyFallbackToLabel = (label) => {
    const swatchEl = label.querySelector(".swatch");
    if (!swatchEl) return;

    const valueRaw = getSwatchLabelValue(label);
    const value = normalize(valueRaw);

    // Try direct match
    let hex = COLOR_MAP[value];

    // Try common variants
    if (!hex && value.includes("light") && value.includes("blue")) hex = COLOR_MAP["light blue"];
    if (!hex && value.includes("military") && value.includes("green")) hex = COLOR_MAP["military green"];

    if (!hex) return;

    // Only set if style isn't already setting a bg (so we don't override real metafields)
    const existing = swatchEl.getAttribute("style") || "";
    const hasBg = /background(-color)?:/i.test(existing);

    if (!hasBg) {
      swatchEl.style.backgroundColor = hex;
    }

    // Extra: make white visible on light backgrounds if needed (CSS already helps)
    // But keep it minimal here.
  };

  const run = (root = document) => {
    // Target only swatch labels (Dawn)
    const swatchLabels = root.querySelectorAll(".swatch-input__label");
    swatchLabels.forEach(applyFallbackToLabel);
  };

  // Initial run
  run();

  // Re-run on variant updates / section rerenders
  const mo = new MutationObserver((muts) => {
    for (const m of muts) {
      if (m.addedNodes && m.addedNodes.length) {
        m.addedNodes.forEach((node) => {
          if (node.nodeType === 1) run(node);
        });
      }
    }
  });

  mo.observe(document.documentElement, { childList: true, subtree: true });

  // Also rerun after change events (safe)
  document.addEventListener("change", (e) => {
    const target = e.target;
    if (!target) return;
    if (target.matches('input[type="radio"], select')) {
      run();
    }
  });
})();
